import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useMembers } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { GridList } from '@tribeplatform/react-ui-kit/Layout';
import { EmptyState } from './EmptyState';
import { FilterBar } from './FilterBar';
import { MemberCard } from './MemberCard';
export const MemberListLoading = ({ count = 16 }) => {
    return (_jsx(_Fragment, { children: [...Array(count)].map((_e, i) => (
        // eslint-disable-next-line react/no-array-index-key
        _jsx(GridList.Item, { children: _jsx(Card, { className: "h-full", children: _jsxs("div", { className: "animate-pulse flex-1 flex flex-col mb-2 p-6 pt-4 space-y-2 items-center text-center", children: [_jsx("div", { className: "mb-3 w-32 h-32 rounded-full bg-skeleton" }, void 0), _jsx("div", { className: "h-4 bg-skeleton rounded-full w-2/3" }, void 0), _jsx("div", { className: "h-4 bg-skeleton rounded-full w-3/4" }, void 0)] }, void 0) }, void 0) }, i))) }, void 0));
};
export const CommunityMemberList = () => {
    const [filters, setFilters] = useState({});
    const { data, fetchNextPage, hasNextPage, isFetched, isLoading, isFetchingNextPage, } = useMembers({
        fields: {
            profilePicture: 'basic',
            banner: 'basic',
            role: 'basic',
            badges: 'default',
        },
        variables: { limit: 30, ...filters },
        useInfiniteQueryOptions: { keepPreviousData: true },
    });
    const { nodes: members } = simplifyPaginatedResult(data);
    return (_jsxs("div", { className: "flex flex-col space-y-5", children: [_jsx(FilterBar, { setFilters: setFilters }, void 0), _jsx(InfiniteScroll, { pageStart: 0, loadMore: fetchNextPage, hasMore: hasNextPage || false, threshold: 800, children: isFetched && !(members === null || members === void 0 ? void 0 : members.length) && !isLoading ? (_jsx(EmptyState, {}, void 0)) : (_jsxs(GridList, { columns: 4, className: "items-stretch", children: [members.map(member => (_jsx(GridList.Item, { children: _jsx(MemberCard, { member: member }, void 0) }, member.id))), !isFetched || isLoading || isFetchingNextPage ? (_jsx(MemberListLoading, {}, void 0)) : null] }, void 0)) }, void 0)] }, void 0));
};
//# sourceMappingURL=CommunityMemberList.js.map